import geoData from './gaode-area.json';
import React, { useState, useEffect} from 'react';
import {Flex, Select, Tag, Space} from 'antd';
import { NumberOutlined } from '@ant-design/icons';
import { SafeStorage } from '../../utils/webview';

const geos = geoData.districts[0].districts;
const provinceOptions = geoData.districts[0].districts.map(item => ({label: item.name, value: item.adcode}));

export default ({id, value, defaultValue, onChange, showHistory = true}) => {
    const [currentProvince, setCurrentProvince] = React.useState({});
    const [currentCity, setCurrentCity] = React.useState({});
    const [currentCounty, setCurrentCounty] = React.useState({});

    const [cityOptions, setCityOptions] = React.useState([]);
    const [countyOptions, setCountyOptions] = React.useState([]);
    const [historyGeo, setHistoryGeo] = React.useState([]);

    // 默认值
    React.useEffect(() => {
        console.log('defaultValue', defaultValue);
        if(defaultValue) {
            const [province, city, county] = defaultValue;
            if(province) {
                setCurrentProvince(province);
            }
            if(city) {
                setCurrentCity(city);
            }
            if(county) {
                setCurrentCounty(county);
            }

            onChange?.([
                province || currentProvince, 
                city || currentCity, 
                county || currentCounty,
            ]);
        }
    }, [defaultValue]);

    // 获取历史地理位置
    React.useEffect(() => {
        const fetchHistoryGeo = async () => {
            try {
                const history = await SafeStorage.getItem('__geo');
                console.log('history', history);
                const parsedHistory = history ? JSON.parse(history) : [];
                setHistoryGeo(parsedHistory);
            } catch (e) {
                console.error('Failed to parse history geo:', e);
                setHistoryGeo([]);
            }
        };
        
        fetchHistoryGeo();
    }, []);

    // 获取省份下城市数据
    useEffect(() => {
        const province = geos.find((item) => item.adcode === currentProvince.adcode);

        if(province) {
            const cities = province.districts.map(item => ({...item, label: item.name, value: item.adcode}));
            setCityOptions(cities);
        }
    }, [currentProvince]);

    // 获取城市下区县数据
    useEffect(() => {
        let city = null;

        geos.forEach(p => {
            if(p.adcode === currentProvince.adcode) {
                city = p.districts.find(c => c.adcode === currentCity.adcode);
            }
        });
        console.log('city', city);
        
        if(city) {
            setCountyOptions(city.districts.map(c => ({...c, label: c.name, value: c.adcode })));
        }
    }, [currentCity]);

    const onGeoChange = (type, v, option) => {
        console.log('onGeoChange', type, v, option);

        if(type === 'province') {
            onGeoChange.province = geos.find((item) => item.adcode === v);

            setCurrentProvince(onGeoChange.province);
            setCurrentCity({});
            setCurrentCounty({});
        }else if(type === 'city') {
            onGeoChange.city = cityOptions.find((item) => item.adcode === v);

            setCurrentCity(onGeoChange.city);
            setCurrentCounty({});
        }else if(type === 'county') {
            onGeoChange.county = countyOptions.find((item) => item.adcode === v);
            // console.log('onGeoChange.county', onGeoChange.county, countyOptions);
            setCurrentCounty(onGeoChange.county);
        }

        if(currentProvince?.adcode && currentCity?.adcode) {
            updateHistoryGeo();
        }

        onChange?.([
            (onGeoChange.province || currentProvince), 
            (onGeoChange.city || currentCity), 
            (onGeoChange.county || currentCounty ),
        ]);
    }

    const updateHistoryGeo = async () => {
        try {
            let stored = await SafeStorage.getItem('__geo') || "[]";
            stored = JSON.parse(stored);

            if(stored instanceof Array && !stored.find(i => i?.[1]?.adcode === currentCity.adcode)) {
                stored.unshift([{name: currentProvince.name, adcode: currentProvince.adcode}, {name: currentCity.name, adcode: currentCity.adcode}]);
                if(stored.length > 5) stored.length = 5;
                await SafeStorage.setItem('__geo', JSON.stringify(stored));
                
                // 更新本地状态
                setHistoryGeo(stored);
            }
        } catch (e) {
            console.error('Failed to update history geo:', e);
        }
    }

    const selecteHistory = (item)  => { 
        const [province, city] = item;
        // console.log(province, city);
        setCurrentProvince(province);
        setCurrentCity(city);
        setCurrentCounty({});
    };

    const removeHistory = async (index) => {
        try {
            let history = await SafeStorage.getItem('__geo');
            history = history ? JSON.parse(history) : [];
            history.splice(index, 1);
            await SafeStorage.setItem('__geo', JSON.stringify(history));
            
            // 更新本地状态
            setHistoryGeo(history);
        } catch (error) {
            console.error('Failed to remove history geo:', error);
        }
    }

    return (
        <div>
            <Flex gap={10} id={id}>
                <Select style={{minWidth: '100px'}} options={provinceOptions} 
                    value={currentProvince.adcode || currentProvince.name} 
                    onChange={(v, item) => onGeoChange('province', v, item)} placeholder="省份" 
                />
                <Select style={{minWidth: '100px'}} options={cityOptions} 
                    value={currentCity.adcode || currentCity.name} 
                    onChange={(v, item) => onGeoChange('city', v, item)} placeholder="城市" 
                />
                <Select style={{minWidth: '100px'}} options={countyOptions} 
                    value={currentCounty.adcode || currentCounty.name} 
                    onChange={(v, item) => onGeoChange('county', v, item)} placeholder="区/县" 
                />
            </Flex>
            <Space style={{ marginTop: '8px'}} size={2}>
                {
                    showHistory && historyGeo.map((item, index) => {
                        return <Tag onClose={() => removeHistory(index)} key={index} onClick={() => selecteHistory(item)}>{item?.[1]?.name}</Tag>
                    })
                }
            </Space>
        </div>
    )
}